import {Store,Module,ActionContext} from 'vuex'
import ListModule from './list-module'
import ListState from './list-state'
import MoistureEquipment from '../entities/moistureequipment'
import Ajax from '../../lib/ajax'
import PageResult from '@/store/entities/page-result';
import ListMutations from './list-mutations'
interface MoistureEquipmentState extends ListState<MoistureEquipment>{
    editMoistureEquipment:MoistureEquipment
    analysemiodata: MoistureEquipment
}
class UserMutations extends ListMutations<MoistureEquipment>{

}
class MoistureEquipmentModule extends ListModule<MoistureEquipmentState,any,MoistureEquipment>{
    state={
        totalCount:0,
        currentPage:1,
        pageSize:10,
        list: new Array<MoistureEquipment>(),
        filterlist:new Array<MoistureEquipment>(),
        analysemiodata:new MoistureEquipment(),
        loading:false,
        editMoistureEquipment:new MoistureEquipment()
    }
    actions={
        async getAll(context:ActionContext<MoistureEquipmentState,any>,payload:any){
            //console.log(payload.data);
            context.state.loading=true;
            let reponse=await Ajax.get('/api/services/app/MoistureEquipment/GetPaged',{params:payload.data});
            context.state.loading=false;
            let page=reponse.data.result as PageResult<MoistureEquipment>;
            context.state.totalCount=page.totalCount;
            context.state.list=page.items;
            context.state.filterlist=page.items;
        },
        async getPaged(context:ActionContext<MoistureEquipmentState,any>,payload:any){
          
            context.state.loading=true;
            //debugger
            let reponse=await Ajax.get('/api/services/app/MoistureEquipment/GetPaged',{params:payload.data});
            
            context.state.loading=false;
            let page=reponse.data.result as PageResult<MoistureEquipment>;
            context.state.totalCount=page.totalCount;
            context.state.list=page.items;
            context.state.filterlist=page.items;
        },
        async getPagedLast(context:ActionContext<MoistureEquipmentState,any>,payload:any){
          
            context.state.loading=true;
            //debugger
            let reponse=await Ajax.get('/api/services/app/MoistureEquipment/GetPaged',{params:payload.data});
            context.state.loading=false;
            let page=reponse.data.result as PageResult<MoistureEquipment>;
            context.state.totalCount=page.totalCount;
            context.state.filterlist=page.items;
            return page.items;
        },
        async getfilter(context:ActionContext<MoistureEquipmentState,any>,payload:any){
            //console.log(payload.data);
            context.state.loading=true;
            let reponse=await Ajax.get('/api/services/app/MoistureEquipment/GetAll',{params:payload.data});
            context.state.loading=false;
            let page=reponse.data.result as PageResult<MoistureEquipment>;
            context.state.totalCount=page.totalCount;
            context.state.filterlist=page.items;
        },
        async create(context:ActionContext<MoistureEquipmentState,any>,payload:any){
            await Ajax.post('/api/services/app/MoistureEquipment/Create',payload.data);
        },
        async uploadimg(context:ActionContext<MoistureEquipmentState,any>,payload:any){
            //console.log(payload.data.UploadData);
            await Ajax.post('/api/services/app/UploadFile/UploadFile',{params:payload.data.UploadData});
        },
        async update(context:ActionContext<MoistureEquipmentState,any>,payload:any){
            await Ajax.put('/api/services/app/MoistureEquipment/Update',payload.data);
        },
        async delete(context:ActionContext<MoistureEquipmentState,any>,payload:any){
            await Ajax.delete('/api/services/app/MoistureEquipment/Delete?Id='+payload.data.id);
        },
        async get(context:ActionContext<MoistureEquipmentState,any>,payload:any){
            let reponse=await Ajax.get('/api/services/app/MoistureEquipment/GetById?Id='+payload.id);
            return reponse.data.result as MoistureEquipment;
        },
         //通过mac获取设备
         async getPageBymac(context:ActionContext<MoistureEquipmentState,any>,payload:any){
            let reponse=await Ajax.get('/api/services/app/MoistureEquipment/GetPaged',{params:payload.data});
            return reponse.data.result.items as MoistureEquipment;
        }
    };
    mutations={
        setCurrentPage(state:MoistureEquipmentState,page:number){
            state.currentPage=page;
        },
        setPageSize(state:MoistureEquipmentState,pagesize:number){
            state.pageSize=pagesize;
        },
        edit(state:MoistureEquipmentState,MoistureEquipment:MoistureEquipment){
            
            state.editMoistureEquipment=MoistureEquipment;
            //console.log(state.editFloor);
        },
        analyse(state: MoistureEquipmentState, miodata: MoistureEquipment) {
            state.analysemiodata = miodata;
        },
    }
}
const moistureequipmentModule=new MoistureEquipmentModule();
export default moistureequipmentModule;